<template>
  <div>
    <v-autocomplete
      ref="autocomplete"
      v-bind="$attrs"
      v-on="$listeners"
      :items="items"
      filled
      dense
      :value="iValue"
    ></v-autocomplete>
    <template v-if="codelist">
      <template v-if="!isReadOnly">
        <v-btn
          small
          text
          color="primary"
          @click="add"
        >
          Add
        </v-btn>
        <v-btn
          small
          text
          color="primary"
          @click="edit"
        >
          Edit
        </v-btn>
      </template>
      <template v-if="this.$refs.autocomplete && isReadOnly">
        <v-btn
          small
          text
          color="primary"
          @click="details"
        >
          Details
        </v-btn>
      </template>
      <embeded-code-list-editor
        code-list-key="air_conditioning_type"
        @updated="updated"
        ref="cEditor"
      ></embeded-code-list-editor>
    </template>
  </div>
</template>

<script>
  import RefreshOnDemand from '@/components/codelist/mixins/RefreshOnDemand'
  import EmbededCodeListEditor from '@/views/code-list/EmbededCodeListEditor'

  export default {
    name: 'AirConditioningType',
    components: { EmbededCodeListEditor },
    props: {
      codelist: {
        default: false,
      },
    },
    mixins: [
      RefreshOnDemand,
    ],
    data () {
      return {
        item: {},
      }
    },
    computed: {
      key () {
        return 'air_conditioning_type'
      },
      isReadOnly () {
        if (this.$refs.autocomplete) {
          return this.$refs.autocomplete.readonly
        } else {
          return false
        }
      },
    },
    methods: {
      add () {
        this.$refs.cEditor.add()
      },
      edit () {
        const itemId = this.$refs.autocomplete.value
        this.$refs.cEditor.edit(itemId)
      },
      details () {
        const itemId = this.$refs.autocomplete.value
        this.$refs.cEditor.details(itemId)
      },
      updated (itemId) {
        this.fetchData()
        this.$emit('input', itemId)
      },
    },
  }
</script>

<style scoped>

</style>
